import { SharedValues } from './../../../core/shared-values';
import { OfferCancellationWarningComponent } from './../../../user/offers/offer-cancellation-warning/offer-cancellation-warning.component';
import {
  Component, OnInit, ViewChild, AfterViewInit, OnDestroy, ElementRef, ChangeDetectorRef, AfterViewChecked
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VendorService } from '../../vendor.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { IVendorItemInfo } from '../../interface/IVendorItemInfo';
import { SharedService } from '../../../shared/shared.service';
import { IErrorModal } from '../../interface/IErrorModal';
import { environment } from '../../../../environments/environment';
import { Subscription, forkJoin } from 'rxjs';
import * as $ from 'jquery';
import { PubSubService } from '../../../core/pubsub.service';
import { SharedSource } from '../../../core/shared-source';
import { ItemService } from '../item.service';
import { ItemDetailedComponent } from '../item-detailed/item-detailed.component';
import { ItemWriteModalComponent } from '../item-write/item-write-modal.component';
import { ItemWriteService } from '../item-write/item-write.service';
import { EDIT_ERROR_CODES, ICloneSource, IConflictMark, IEditHeader, IItemProblemDetails, ILookupCategory, ItemResponse } from '../item-write/item.models';
import { rowConflictMarks } from './listing-conflict.rules';
import { IBatchSaveContext, RowSaveOutcome } from '../item-write/item-batch-save.service';
import { RELOAD_FAILED, SAVE_RESULT_TITLE, SHOW_UNSAVED_ACTION, editSuccessNote, errorFor, fixOnItemsFirst, genericWriteError, itemsKeptText, itemsNotSavedText, itemsSavedText, listingInvalidMessage, reviewOnItemsFirst } from '../item-write/rules/item-write-messages';
import { IResolveRow, ResolveChoice, itemSide, resolveRows, resolvedEdit } from '../item-write/rules/item-write-resolve.rules';
import { ConflictResolveComponent } from '../item-write/conflict-resolve/conflict-resolve.component';
import { ItemListingService } from './item-listing.service';
import { ItemListingSaveService, IListingSavePlan, IListingSaveSummary } from './item-listing-save.service';
import { ItemEditStore } from './item-edit.store';
import { IListingFilterOptions, IListingFilters, IListingPagination, IListingRow, IStatusCounter } from './item-listing.models';
import { categoryIdsForChoice, restrictionOptions as toRestrictionOptions, subCategoriesOf } from './listing-filter-bar.rules';
import {
  IListingPageState, IListingTabView, ListingTrigger, countOf, fallbackTab, fetchPlan, initialListingState,
  pageQuery, routeNameOf, tabFromRouteName, tabsForDisplay, withFilters, withPage, withSearch, withSortToggled, withTab,
  withoutFilters
} from './listing-page.rules';
import { ListingRole, isSelectableForReactivation, rowSavedNote } from './listing-row.rules';
import { manufacturerLogoPath } from './manufacturer-logo';
import { IListingRowLookups } from '../item-simple/item-simple.component';

import { saveAs as importedSaveAs } from 'file-saver';
import { IItemsExportRequest } from '../../interface/IItemsExportRequest';
import { IExw } from '../../interface/IExw';
import { INameId } from '../../interface/INameId';
import { IVendorManufacturer } from '../../interface/IVendorManufacturer';
import { IVendorPromo } from '../../interface/IVendorPromo';
import { IVendorSubCategory } from '../../interface/IVendorSubCategory';
import { LoaderService } from '../../../shared/services/loader.service';
import { OfferService } from '../../../user/offers/offer.service';
import * as models from './../../../shared/interfaces/model';
import * as moment from 'moment-timezone';
import * as enums from '../../../shared/enums/enum';
import { ItemSimpleComponent } from '../item-simple/item-simple.component';
import { OfferCancellationWarningComponent as OfferCancellationWarningComponent_1 } from '../../../user/offers/offer-cancellation-warning/offer-cancellation-warning.component';
import { ErrorModalComponent } from '../../../shared/ui-components/error-modal/error-modal.component';
import { ItemUpdatingModalComponent } from '../item-updating-modal/item-updating-modal.component';
import { ItemSuccessComponent } from '../item-success/item-success.component';
import { PaginationComponent, PaginationModule } from 'ngx-bootstrap/pagination';
import { ItemsEmptyComponent } from '../items-empty/items-empty.component';
import { VendorItemsPreloaderComponent } from '../../../shared/ui-components/vendor-items-preloader/vendor-items-preloader.component';
import { CustomSelectComponent } from '../../../shared/ui-components/custom-select/custom-select.component';
import { ConfirmModalComponent } from '../../../shared/confirm-modal/confirm-modal.component';
import { NgClickOutsideDirective, NgClickOutsideExcludeDirective } from 'ng-click-outside2';
import { NgIf, NgFor, NgClass } from '@angular/common';

/**
 * The Product Listings page on the v2 listing (HUBX-8479, with the rows of HUBX-8480 and
 * HUBX-8481).
 *
 * Everything the page asks for is ONE IListingPageState (tab by name, filters, sort, page),
 * replaced through the pure transitions of listing-page.rules, and each trigger fetches exactly
 * what fetchPlan says (design page "Listing › When the client calls what"):
 * - GET /items fills the ItemEditStore, which holds every row as stored and ONE
 *   Map<id, ItemResponse> of edits. The rows build their forms from it on demand.
 * - GET /items/status-counts draws the tab strip; the selected bucket's count is the pager's
 *   total, so a save corrects it without refetching the page.
 * - GET /items/filter-options fills the filter bar from the vendor's whole catalogue.
 * A save is N single-item PUTs through ItemListingSaveService: the legacy pending-offers gate,
 * then the fan-out, then a refill of the saved rows by id - never GET /items - and the two
 * aggregates.
 *
 * Gone with it: the parent-held `itemsForm`, `vendorService.updatedMappedItems` and the partial
 * `itemRequest`, `applyChangetoUpdatedItem` / `adjustUpdatedMappedItems` in the rows, the
 * legacy VendorItem/Items and VendorItem/internalVendorItem calls, `addErrorsToItems` (which
 * shrank the grid to the failed rows), and legacy-listing.adapter.
 */
@Component({
    selector: 'app-items',
    templateUrl: './items.component.html',
    styleUrls: ['./items.component.scss'],
    standalone: true,
    imports: [NgIf, NgClickOutsideDirective, FormsModule, NgFor, CustomSelectComponent, NgClass, ItemDetailedComponent, VendorItemsPreloaderComponent, ReactiveFormsModule, ItemSimpleComponent, ItemsEmptyComponent, PaginationModule, ItemSuccessComponent, ItemUpdatingModalComponent, ErrorModalComponent, OfferCancellationWarningComponent_1, NgClickOutsideExcludeDirective, ItemWriteModalComponent, ConfirmModalComponent, ConflictResolveComponent]
})
export class ItemsComponent implements OnInit, AfterViewInit, OnDestroy, AfterViewChecked {
  @ViewChild('updatedItemsAlert') autoShownModal: ModalDirective;
  @ViewChild(PaginationComponent) pager?: PaginationComponent;
  @ViewChild(OfferCancellationWarningComponent) offerCancelationWarningComponent!: OfferCancellationWarningComponent;
  /** The Edit modal, to hand it the warning's answer (HUBX-8511). */
  @ViewChild(ItemWriteModalComponent) writeModal?: ItemWriteModalComponent;

  // ---------------------------------------------------------------------------------------
  // Page state
  // ---------------------------------------------------------------------------------------

  /** What the page asks for (listing-page.rules). */
  state: IListingPageState = initialListingState();
  /** The rows as stored plus the edits (HUBX-8479). The unsaved-only view closes when the last
   *  edit leaves, whichever path took it (HUBX-8466). */
  readonly store = new ItemEditStore(() => { this.showOnlyEdited = false; });
  tabs: IListingTabView[] = [];
  pagination: IListingPagination = { totalCount: 0, pageSize: environment.vendorItemsPageSize, currentPage: 1, totalPages: 0 };
  /** The pager's page, two-way bound so a refused page change can be put back. */
  pagerPage = 1;
  /** The dashboard deep link chose the tab: an empty tab is then shown, not replaced by All. */
  private tabPinnedByRoute = false;
  /** Everything a row seeds and renders through, from /lookups (cached per tab). */
  lookups: IListingRowLookups = { categories: [], manufacturers: [], exwPoints: [] };
  lookupsReady = false;
  /** Bumped per row when the store moved it behind its form, so the row rebuilds. */
  private revisions = new Map<string, number>();
  /** The last save's failure per row, worded by the shared catalogue (minimum of HUBX-8478). */
  saveErrors = new Map<string, string>();
  /** The discount tier a row's last failure names, by its From Quantity (the cost-margin 400,
   *  HUBX-8466), kept with the line it came with: saveErrorDq answers only while that line is
   *  still the row's, so every path that changes or clears the line drops the ring with it. */
  private readonly saveErrorTiers = new Map<string, { message: string; fromQty: number }>();

  saveErrorDq(id: string): number | null {
    const tier = this.saveErrorTiers.get(id);
    return tier && this.saveErrors.get(id) === tier.message ? tier.fromQty : null;
  }

  /** The rows whose last save the server refused over their data (a 400, HUBX-8466), kept with
   *  the line it came with, as saveErrorTiers: isRefused answers only while that line is still
   *  the row's, so the edit that clears it - or any later outcome - lets the row save again.
   *  The ProblemDetails is kept beside it, for the Edit popup opened on the row (refusalOf). */
  private readonly refusals = new Map<string, { message: string; problem: IItemProblemDetails | null }>();

  /** Sent again unchanged, the row would be refused again: its Save and Update All wait for an
   *  edit (HUBX-8466). */
  isRefused(id: string): boolean {
    const refusal = this.refusals.get(id);
    return refusal !== undefined && this.saveErrors.get(id) === refusal.message;
  }

  /** The 400 the row is refused with, while it is (isRefused): the Edit popup opened on the row
   *  sends the same edit, so it opens refused the same way (HUBX-8466). Empty when the 400 came
   *  without a body - the popup then says the generic line, as the row does. */
  private refusalOf(id: string): IItemProblemDetails | undefined {
    return this.isRefused(id) ? this.refusals.get(id)?.problem ?? {} : undefined;
  }

  /** How many status tabs stay on the strip before the rest fold into "More". Must match the
   *  nth-child(n+5) rule in items.component.scss that hides the overflow below 1460px. */
  readonly visibleStatusTabs = 4;

  // ---------------------------------------------------------------------------------------
  // Filter bar (HUBX-8487): choices from GET /items/filter-options, chosen objects kept here
  // ---------------------------------------------------------------------------------------

  manufacturers: IVendorManufacturer[];
  promos: IVendorPromo[];
  exwPoints: IExw[] = [];
  subCategories: IVendorSubCategory[] = [];
  categoryOptions: ILookupCategory[] = [];
  restrictionOptions: INameId[] = [];
  categorySelected: any;
  subCategorySelected: any;
  selectedManufacturer: any;
  selectedPromotion: any;
  selectedRestriction: any;
  selectedExw: any;

  // ---------------------------------------------------------------------------------------
  // Legacy page chrome, unchanged
  // ---------------------------------------------------------------------------------------

  isSearchFocused = false;
  loader = false;
  isSearched = false;
  totalUpdatedItemsCount = 0;
  /** Rows the last save did not write: server failures and pre-flight refusals (HUBX-8478). */
  totalFailedItemsCount = 0;
  /** Rows the last save did not send because the user kept their offers (HUBX-8511). */
  totalKeptItemsCount = 0;
  /** The updates in the save the offers warning is open for (HUBX-8511): the rows the check
   *  left to send (HUBX-8466) - for Update All, what "Update All Listings (##)" showed less any
   *  row whose check failed; 1 for a row's Save. The warning counts down from it. */
  pendingUpdatesInSave = 0;
  /** Who opened the cancellation warning, and so gets its answer: the listing's save or the
   *  Edit modal's (HUBX-8511). */
  private warningFrom: 'listing' | 'modal' = 'listing';
  /** The cancellation warning is open over the Edit modal, for as long as it is open, so it
   *  covers the window as the modal does (HUBX-8511). Unlike warningFrom, an answer does not
   *  clear it: the warning does not move while it closes. */
  warningOverModal = false;
  errorModal: IErrorModal = { isError400: false, errorMessage400: '' };
  itemsTitle = 'Product Listings';
  paginationMaxSize = 5;
  isPaginationDisabled = false;
  nothingFoundMessage = environment.vendorItemsMessage;
  nothingFoundMinorMessage = environment.vendorItemsMinorMessage;
  nothingFoundButtonTxt = environment.vendorItemsButtonText;
  isAllVendors = false;
  isModalShown = false;
  isUpdatingItems = false;
  isShowExportTooltip = false;
  isAllExport = false;
  isExporting = false;
  exportReq: IItemsExportRequest;
  exportReqOptions: number[];
  vendorHomeElem: ElementRef;
  isMoreShown = false;
  /** "Unsaved Listings": the page narrowed to its edited rows. */
  showOnlyEdited = false;
  /** Rows saved while "Unsaved Listings" is on (HUBX-8498). They stay in that view, marked,
   *  until it is left - a row does not vanish under the user's hand because it saved. */
  private readonly savedWhileFiltered = new Set<string>();

  // Removed tab: the bulk "reduce cost to reactivate" (kept, rewired to the store - HUBX-8480)
  reactivationSelected = new Set<string>();
  isAllRemovedSelected = false;

  // Unsaved edits on the way out (design page "Unsaved edits on page change")
  discardPrompt: { proceed: () => void; cancel?: () => void } | null = null;
  readonly discardMessage = ['You have unsaved changes on this page.', 'Continuing will discard them.'];

  // Save: the pending-offers gate, unchanged in behaviour (HUBX-8477)
  pendingOffers: models.ItemWithPendingOffers[] = [];
  isRequestingPendingOffers = false;
  showRefreshMsg = false;
  showCancellationWarning = false;
  offersSubscriptions: Subscription[] = [];
  EventTypesEnum = enums.OfferEventTypes;
  isCheckPendingOffersSingleItem = true;
  totalPendingOffers = 0;
  disableReviewOffersButton = true;
  private savePlan?: IListingSavePlan;

  private pageSubscription = new Subscription();
  private countsSubscription = new Subscription();
  private filterOptionsSubscription = new Subscription();
  private lookupsSubscription = new Subscription();
  private saveSubscription = new Subscription();
  private refillSubscription = new Subscription();
  pubSubSubscription: Subscription;
  vendorDataSubscription: Subscription;

  // ---------------------------------------------------------------------------------------
  // The write modal (Create / Clone / Edit - HUBX-8385 / 8368 / 8388)
  // ---------------------------------------------------------------------------------------

  private _showWriteModal = false;

  /** Write modal open flag — Create, Clone and Edit all render the SAME component, so they
   *  share one flag; which mode it opens in is decided by the inputs. Routed through a setter
   *  so opening also freezes the page's horizontal scroll and closing restores it (the app's
   *  1000px desktop floor leaves a scrollbar behind the modal's backdrop). */
  get showWriteModal(): boolean {
    return this._showWriteModal;
  }
  set showWriteModal(open: boolean) {
    this._showWriteModal = open;
    this.elRef.nativeElement.ownerDocument.documentElement.style.overflowX = open ? 'hidden' : '';
  }

  showCreateSuccessModal = false;
  createSuccessMsg = '';
  createCategoryNotice = '';
  cloneSeed?: ItemResponse;
  cloneSource?: ICloneSource;
  cloneSubscription: Subscription;

  /** Edit (HUBX-8388): the item as stored - from the row on this page, fetched on pending-sold. */
  editTarget?: ItemResponse;
  /** Edit from a listing row (HUBX-8480): that row's unsaved edit, seeded over the target. */
  editPending?: ItemResponse;
  /** Edit from a refused listing row (HUBX-8466): the 400 that row's edit was refused with. */
  editRefusal?: IItemProblemDetails;
  editHeader?: IEditHeader;
  /** The row's reactivation threshold (HUBX-8476), which only the v2 row carries. */
  editReactivationThreshold?: number | null;
  /** The listing row the modal was opened from: highlighted while it is open. */
  editRowId?: string;
  /** The company of the item the modal edits when no listing row carries it (pending-sold,
   *  HUBX-8511): the legacy item's seller, as master's single-item warning read it. */
  editSellerId?: string;
  editSubscription: Subscription;

  showEditSuccessModal = false;
  editSuccessMsg = '';
  editCategoryNotice = '';

  constructor(
    public vendorService: VendorService,
    protected elRef: ElementRef,
    protected sharedService: SharedService,
    protected route: ActivatedRoute,
    public pubSubService: PubSubService,
    protected router: Router,
    protected cdr: ChangeDetectorRef,
    public itemService: ItemService,
    public loaderService: LoaderService,
    public offerService: OfferService,
    protected itemCreateService: ItemWriteService,
    protected itemListingService: ItemListingService,
    protected listingSaveService: ItemListingSaveService
  ) { }

  get preSelectedStatus(): string | null {
    return this.route.snapshot.paramMap.get('statusName');
  }

  get role(): ListingRole {
    if (this.vendorService.isSeller) { return 'SELLER'; }
    return this.vendorService.isVendorManager ? 'VM' : 'ADMIN';
  }

  /** ADMIN / VENDORMGR: the form factory's role gate (sale pricing, XID). */
  get isPricingRole(): boolean {
    return this.vendorService.isAdmin || this.vendorService.isVendorManager;
  }

  /** The rows on screen: the page, or under "Unsaved Listings" its edited rows plus the ones
   *  saved while that view was on (HUBX-8498) - the rule a tab follows for a row that leaves
   *  its bucket: it stays put, marked, until the next view. */
  get rows(): readonly IListingRow[] {
    return this.showOnlyEdited && this.store.editedCount
      ? this.store.rows.filter(r => this.store.isEdited(r.item.id) || this.savedWhileFiltered.has(r.item.id))
      : this.store.rows;
  }

  /** The selected bucket's count: the header badge and the pager's total (see countOf). */
  get totalCountDisplay(): number {
    return this.tabs.length ? countOf(this.tabs, this.state.tab) : this.pagination.totalCount;
  }

  get isRemovedTab(): boolean {
    return this.state.tab === 'Removed';
  }

  get pendingForReactivation(): number {
    return this.reactivationSelected.size;
  }

  get selectedStatus(): IListingTabView | undefined {
    return this.tabs.find(t => t.tab === this.state.tab);
  }

  /** True when the selected tab sits past the visible ones, i.e. inside "More". */
  get isSelectedStatusInMore(): boolean {
    return this.tabs.findIndex(t => t.tab === this.state.tab) >= this.visibleStatusTabs;
  }

  private get saveContext(): IBatchSaveContext {
    return { lookups: this.lookups, pricing: this.isPricingRole };
  }

  ngOnInit(): void {
    this.setUpPubSub();
    this.loadLookups();
    this.loadVendorsForAdmin();
    this.getVendorItems();
    this.elRef.nativeElement.ownerDocument.body.style.overflow = 'hidden';
  }

  ngOnDestroy(): void {
    this.clearAllSaved();
    this.pubSubSubscription?.unsubscribe();
    this.vendorDataSubscription?.unsubscribe();
    this.vendorService.searchString = '';
    this.elRef.nativeElement.ownerDocument.body.style.overflow = null;
    // Defensive: never leave the global horizontal scroll frozen if the page is torn down
    // with the modal still up (the setter only fires on assignment).
    this.elRef.nativeElement.ownerDocument.documentElement.style.overflowX = '';
    this.offersSubscriptions.forEach(s => s.unsubscribe());
    this.cloneSubscription?.unsubscribe();
    this.editSubscription?.unsubscribe();
    this.cancelAllHttpCalls();
    this.lookupsSubscription.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.vendorHomeElem = this.elRef.nativeElement.closest('.vendor-home');
  }

  ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

  setUpPubSub(): void {
    this.pubSubSubscription = this.pubSubService.sharedSubject.subscribe(
      mySharedValues => {
        if (mySharedValues.name == SharedSource.handleNewOfferEventReceived) {
          this.handleNewOfferEventReceived(mySharedValues.data);
        }
        if (mySharedValues.name === SharedSource.vendorComponentUpdated) {
          if (mySharedValues.data === 'ItemsComponent') {
            this.cancelAllHttpCalls();
          }
        }
        if (mySharedValues.name === SharedSource.changeCustomerVendor) {
          // Another company: its rows are another page, and the edits here cannot follow.
          this.resetAllDropdowns();
          this.vendorService.searchString = '';
          this.isAllVendors = false;
          this.state = withoutFilters();
          this.load('vendor');
        }
      });
  }

  cancelAllHttpCalls(): void {
    this.pageSubscription.unsubscribe();
    this.countsSubscription.unsubscribe();
    this.filterOptionsSubscription.unsubscribe();
    this.saveSubscription.unsubscribe();
    this.refillSubscription.unsubscribe();
  }

  /** The row lookups, the same four the popup reads (ItemWriteService caches them per tab).
   *  The rows are drawn once these are in: seeding a form needs the category tree and the
   *  three attributes. The category tree also expands a filter-bar choice (categoryIdsForChoice). */
  private loadLookups(): void {
    this.lookupsSubscription = forkJoin([
      this.itemCreateService.getCategories(),
      this.itemCreateService.getManufacturers(),
      this.itemCreateService.getAttributes(),
      this.itemCreateService.getExwPoints()
    ]).subscribe({
      next: ([categories, manufacturers, attributes, exwPoints]) => {
        this.lookups = {
          categories,
          manufacturers,
          exwPoints,
          condition: attributes.find(a => a.label === 'Condition'),
          warranty: attributes.find(a => a.label === 'Warranty'),
          packaging: attributes.find(a => a.label === 'Packaging')
        };
        this.lookupsReady = true;
      },
      error: err => this.sharedService.handleVendorHttpError(err, this.errorModal, this.vendorService.portal)
    });
  }

  /** Unchanged side effect of the old dropdown load: an ADMIN's vendor list for the header. */
  private loadVendorsForAdmin(): void {
    if (this.vendorService.isUser(['ADMIN', 'SUPER']) && !this.vendorService.vendors.length) {
      this.vendorDataSubscription = this.vendorService.getAllVendors().subscribe(
        vendorsData => this.vendorService.vendors = vendorsData,
        err => this.sharedService.handleVendorHttpError(err, this.errorModal, this.vendorService.portal)
      );
    }
  }

  // ---------------------------------------------------------------------------------------
  // Fetching
  // ---------------------------------------------------------------------------------------

  /** First load: the tab from the dashboard deep link (by label, "Sold Out" included), else
   *  Active. */
  getVendorItems(): void {
    const routed = !this.vendorService.searchString ? tabFromRouteName(this.preSelectedStatus) : undefined;
    this.tabPinnedByRoute = !!routed;
    this.state = routed ? withTab(initialListingState(), routed) : initialListingState();
    this.load('firstLoad');
  }

  /** Fetch what `trigger` needs (fetchPlan), for the current state. Each read unsubscribes its
   *  own in-flight call first, so a superseded answer is dropped rather than applied. */
  protected load(trigger: ListingTrigger): void {
    const plan = fetchPlan(trigger);
    if (plan.page) {
      this.loader = true;
      this.isPaginationDisabled = true;
      this.loaderService.setLoaderVendorVisible(true);
      this.pageSubscription.unsubscribe();
      this.pageSubscription = this.itemListingService.getPage(pageQuery(this.state)).subscribe({
        next: page => this.applyPage(page.items, page.pagination),
        error: err => {
          this.loader = false;
          this.isPaginationDisabled = false;
          this.loaderService.setLoaderVendorVisible(false);
          this.sharedService.handleVendorHttpError(err, this.errorModal, this.vendorService.portal);
        }
      });
    }
    if (plan.statusCounts) {
      this.countsSubscription.unsubscribe();
      this.countsSubscription = this.itemListingService.getStatusCounts(this.state.filters).subscribe({
        next: counters => this.applyCounters(counters),
        error: err => console.log('Error on get status counts', err)
      });
    }
    if (plan.filterOptions) {
      this.refreshFilterOptions();
    }
  }

  /** A new page: it replaces the store, and with it every edit of the page before. */
  private applyPage(items: IListingRow[], pagination: IListingPagination): void {
    this.store.load(items);
    this.pagination = pagination;
    this.pagerPage = pagination.currentPage;
    this.revisions.clear();
    this.saveErrors.clear();
    this.refusals.clear();
    this.verdicts.clear();
    this.conflicts.clear();
    this.closeResolve();
    this.clearAllSaved();
    this.showOnlyEdited = false;
    this.resetReactivationCheckboxes();
    this.loader = false;
    this.isPaginationDisabled = false;
    this.loaderService.setLoaderVendorVisible(false);
    this.redrawPager();
  }

  /** The tab strip, straight from the counters. Legacy parity: a selected tab left empty falls
   *  back to All - unless the dashboard link asked for it - and the page is fetched again. */
  private applyCounters(counters: IStatusCounter[]): void {
    this.tabs = tabsForDisplay(counters);
    const tab = fallbackTab(this.tabs, this.state.tab, this.tabPinnedByRoute);
    if (tab !== this.state.tab) {
      this.state = withTab(this.state, tab);
      this.load('tab');
    }
    this.redrawPager();
  }

  /**
   * ngx-bootstrap's pagination turns a new [totalItems] into buttons only through its own
   * selectPage, which does nothing while [disabled] is on - and it is on while a page loads,
   * which is exactly when the counters land on the first load (it stayed on "1"). After a
   * save only the counters move, and it kept the old buttons over a total of one page.
   * So whenever the total or the page may have moved: push the bindings now, then hand the
   * pager its value again - writeValue rebuilds the buttons whatever [disabled] says.
   */
  private redrawPager(): void {
    if (!this.pager) { return; }
    this.cdr.detectChanges();
    this.pager.writeValue(this.pagerPage);
  }

  /**
   * The filter bar's choices (GET /items/filter-options, HUBX-8487): the session vendor's whole
   * catalogue, which no filter, tab, search or page moves. Asked for when fetchPlan says the
   * catalogue can have changed or is another one: first load, vendor switch, the header click,
   * and after a create, clone or save. A failure keeps the lists already shown; the next of
   * those events retries. It never blocks the rows.
   */
  refreshFilterOptions(): void {
    this.filterOptionsSubscription.unsubscribe();
    this.filterOptionsSubscription = this.itemListingService.getFilterOptions().subscribe({
      next: options => this.applyFilterOptions(options),
      error: err => console.log('Error on get filter options', err)
    });
  }

  /** The lists are replaced; the CHOSEN values are not touched (HUBX-8479): a choice with no
   *  rows stays chosen and sent until the user changes or clears it. */
  private applyFilterOptions(options: IListingFilterOptions): void {
    this.manufacturers = [...options.manufacturers] as IVendorManufacturer[];
    this.promos = [...options.promos] as IVendorPromo[];
    this.exwPoints = [...options.exw] as IExw[];
    this.categoryOptions = [...options.categories];
    this.subCategories = subCategoriesOf(this.categoryOptions, this.categorySelected?.categoryId) as IVendorSubCategory[];
    this.restrictionOptions = toRestrictionOptions(options.restrictions);
  }

  // ---------------------------------------------------------------------------------------
  // Leaving the page with unsaved edits asks first
  // ---------------------------------------------------------------------------------------

  /** Run `proceed` now, or after the user confirms discarding this page's edits. The discard
   *  itself stays (design page): carrying edits across pages leaves changes the user cannot
   *  see and removes the 25-row bound of the fan-out. What is added is the question. */
  private leavePage(proceed: () => void, cancel?: () => void): void {
    if (!this.store.needsDiscardConfirmation) {
      proceed();
      return;
    }
    this.discardPrompt = { proceed, cancel };
  }

  onDiscardAnswered(confirmed: boolean): void {
    const prompt = this.discardPrompt;
    this.discardPrompt = null;
    if (confirmed) {
      prompt?.proceed();
    } else {
      prompt?.cancel?.();
    }
  }

  /** A cancelled dropdown choice: hand the select a NEW reference to what it showed before,
   *  so it drops the choice it already displays. */
  private static restoreChoice<T>(previous: T): T {
    if (previous && typeof previous === 'object') {
      return { ...(previous as object) } as T;
    }
    return (previous === null ? undefined : null) as unknown as T;
  }

  // ---------------------------------------------------------------------------------------
  // Triggers
  // ---------------------------------------------------------------------------------------

  clickedInside($event: Event): void {
    $event.preventDefault();
    $event.stopPropagation();
  }

  scrollTop(): void {
    $('.items-list').scrollTop(0);
  }

  onKeyPressOnSearch(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.search();
    }
  }

  expandSearch(): void {
    this.isSearchFocused = !this.isSearchFocused;
  }

  /** The search box. A search clears the filter bar and moves to All (design page "Search
   *  clears the filter bar"); an empty one is the first-load state. */
  search(): void {
    this.isSearchFocused = false;
    this.leavePage(() => {
      this.state = withSearch(this.state, this.vendorService.searchString ?? '');
      this.vendorService.searchString = this.state.filters.q ?? '';
      this.isAllVendors = !!this.state.filters.q;
      this.tabPinnedByRoute = false;
      this.resetAllDropdowns();
      // Coming from the dashboard: the route names a tab the search just left.
      if (this.preSelectedStatus && this.preSelectedStatus !== 'All') {
        this.router.navigate(['../All'], { relativeTo: this.route });
      }
      if (this.vendorService.isVendorManager && !this.itemService.vendorManagerMap) {
        this.itemService.getVendorManagerDiccionary();
      }
      this.load('search');
    });
  }

  /** The header: nothing chosen, nothing typed, back on Active. */
  refreshItemsData(): void {
    this.leavePage(() => {
      this.vendorService.searchString = '';
      this.isAllVendors = false;
      this.tabPinnedByRoute = false;
      this.resetAllDropdowns();
      this.state = withoutFilters();
      this.load('clear');
    });
  }

  resetAllDropdowns(): void {
    this.categorySelected = undefined;
    this.subCategorySelected = undefined;
    this.selectedManufacturer = undefined;
    this.selectedPromotion = undefined;
    this.selectedRestriction = undefined;
    this.selectedExw = undefined;
    this.subCategories = [];
  }

  /** The one sort, the other direction. v2 orders before paging, so page 1 is the 25 rows
   *  with the most (or least) inventory in the whole result set. */
  sortByAvailable(): void {
    this.leavePage(() => {
      this.state = withSortToggled(this.state);
      this.load('sort');
    });
  }

  selectStatusAndRetrieveItems(tab: IListingTabView): void {
    this.hideMore();
    if (tab.tab === this.state.tab) { return; }
    this.leavePage(() => {
      this.state = withTab(this.state, tab.tab);
      this.tabPinnedByRoute = false;
      this.resetReactivationCheckboxes();
      this.load('tab');
      if (this.preSelectedStatus) {
        this.router.navigate(['/vendor/items/status/' + routeNameOf(tab.tab)]);
      }
    });
  }

  pageChanged(event: { page: number }): void {
    if (event.page === this.state.page) { return; }
    this.leavePage(
      () => {
        this.state = withPage(this.state, event.page);
        this.load('page');
      },
      // The pager already moved: put it back on the page still shown.
      () => setTimeout(() => this.pagerPage = this.state.page));
  }

  /** A filter-bar choice lands on Active with the search cleared (withFilters, legacy parity). */
  private applyFilters(patch: Partial<IListingFilters>): void {
    this.state = withFilters(this.state, patch);
    this.vendorService.searchString = '';
    this.isAllVendors = false;
    this.tabPinnedByRoute = false;
    this.load('filter');
  }

  /** HUBX-8479: what travels is expanded against the full /lookups/categories tree
   *  (categoryIdsForChoice); Sub Category offers the chosen root's children from the facet. */
  selectCategory(category: any): void {
    const previous = this.categorySelected;
    this.leavePage(() => {
      this.categorySelected = category;
      this.subCategories = subCategoriesOf(this.categoryOptions, category?.categoryId) as IVendorSubCategory[];
      this.subCategorySelected = undefined;
      const ids = categoryIdsForChoice(this.lookups.categories, category, null);
      this.applyFilters({ categoryIds: ids?.length ? ids : undefined });
    }, () => this.categorySelected = ItemsComponent.restoreChoice(previous));
  }

  selectSubCategory(subCategory: any): void {
    const previous = this.subCategorySelected;
    this.leavePage(() => {
      this.subCategorySelected = subCategory;
      const ids = categoryIdsForChoice(this.lookups.categories, this.categorySelected, subCategory);
      this.applyFilters({ categoryIds: ids?.length ? ids : undefined });
    }, () => this.subCategorySelected = ItemsComponent.restoreChoice(previous));
  }

  manufacturerSelected(manufacturer: any): void {
    const previous = this.selectedManufacturer;
    this.leavePage(() => {
      this.selectedManufacturer = manufacturer;
      this.applyFilters({ manufacturerId: manufacturer?.name !== 'All' ? manufacturer?.id || undefined : undefined });
    }, () => this.selectedManufacturer = ItemsComponent.restoreChoice(previous));
  }

  promotionSelected(promo: any): void {
    const previous = this.selectedPromotion;
    this.leavePage(() => {
      this.selectedPromotion = promo;
      this.applyFilters({ promoId: promo?.name !== 'All' ? promo?.id || undefined : undefined });
    }, () => this.selectedPromotion = ItemsComponent.restoreChoice(previous));
  }

  selectRestriction(restriction: INameId): void {
    const previous = this.selectedRestriction;
    this.leavePage(() => {
      this.selectedRestriction = restriction;
      const value = restriction?.id;
      this.applyFilters({ restrictions: value === 'yes' || value === 'no' ? value : undefined });
    }, () => this.selectedRestriction = ItemsComponent.restoreChoice(previous));
  }

  selectExw(exw: IExw): void {
    const previous = this.selectedExw;
    this.leavePage(() => {
      this.selectedExw = exw;
      this.applyFilters({ exw: exw?.value ?? undefined });
    }, () => this.selectedExw = ItemsComponent.restoreChoice(previous));
  }

  showMore(): void {
    this.isMoreShown = true;
  }

  hideMore(): void {
    this.isMoreShown = false;
  }

  /** Method to change the view of the vendor items - 'excel' or 'detailed'. The rows build
   *  their forms from the store, so switching keeps every edit. */
  changeView(viewType: string): void {
    this.vendorService.vendorItemsSavedInfo.viewType = viewType;
    if (this.vendorService.vendorItemsSavedInfo.useAnalytics) {
      this.vendorService.vendorItemsSavedInfo.useAnalytics = false;
    }
  }

  // ---------------------------------------------------------------------------------------
  // Rows
  // ---------------------------------------------------------------------------------------

  trackById(_: number, row: IListingRow): string {
    return row.item.id;
  }

  revisionOf(id: string): number {
    return this.revisions.get(id) ?? 0;
  }

  /** Rows a save answered with a 412 (HUBX-8478), with the members to ring - empty when the
   *  412 carried no currentState. The row shows the amber notice with Review changes, cannot
   *  be saved, and blocks Update All Listings, until it is resolved in the resolve popup, undone
   *  (which re-reads it), or the page is left (HUBX-8466). */
  readonly conflicts = new Map<string, Map<string, IConflictMark>>();

  /** The resolve popup (HUBX-8466): the row it is open on, its rows once the item is re-read
   *  (null while it is), a failed re-read, and the row the re-read returned - the new baseline
   *  when the popup is answered. */
  resolveId: string | null = null;
  resolveRows: IResolveRow[] | null = null;
  resolveError: string | null = null;
  private resolveFresh: IListingRow | null = null;

  /** How long a row's success mark stays once the result popup is closed (HUBX-8478). */
  static readonly SAVED_MARK_MS = 10000;

  /** Rows the last save wrote, marked in place (HUBX-8478). The mark is an acknowledgement,
   *  not state: it fades SAVED_MARK_MS after the result popup is closed - the popup covers
   *  the rows, so a countdown running under it would spend the mark unseen - or on the next
   *  edit of that row, unlike the failure mark, which is outstanding work and stays until the
   *  row is corrected or undone. A permanent green would compete with the review and
   *  reactivation notices, which ARE state. */
  readonly justSaved = new Set<string>();
  private readonly savedTimers = new Map<string, ReturnType<typeof setTimeout>>();
  /** What a saved mark says instead of "Saved." (HUBX-8466): approved or reactivated, and
   *  still Paused by the vendor. Worked out when the save starts, from the status each row
   *  sends and the row as stored; it goes with the mark. */
  readonly savedNotes = new Map<string, string>();
  private plannedSavedNotes = new Map<string, string>();

  /** The store moved this row behind its form: rebuild it. */
  private bump(id: string): void {
    this.revisions.set(id, this.revisionOf(id) + 1);
  }

  onRowEdited(id: string): void {
    // An edit made after a failed save is the user correcting it.
    this.saveErrors.delete(id);
    this.clearSaved(id);
    // Undone, or typed back to the stored state: on a conflicted row that state is the stale
    // one, so the row is re-read - Undo there is Discard my changes (HUBX-8466).
    if (!this.store.isEdited(id) && this.conflicts.has(id)) {
      this.discardConflicts([id]);
    }
  }

  isReactivationSelectable(row: IListingRow): boolean {
    return isSelectableForReactivation(this.state.tab, row);
  }

  /** "Clear": every edit on the page undone from memory. No request - legacy reloaded - except
   *  for the conflicted rows, whose stored state is stale: those are re-read, as their own Undo
   *  does (HUBX-8466). */
  clearAllUpdatedItems(): void {
    const conflicted = [...this.conflicts.keys()];
    for (const id of this.store.editedIds) {
      this.bump(id);
    }
    this.store.undoAll();
    this.saveErrors.clear();
    this.resetReactivationCheckboxes();
    if (conflicted.length) {
      this.discardConflicts(conflicted);
    }
  }

  // What keeps a save from going (HUBX-8466). One rule per row - a conflict to review, an edit
  // the pre-flight refuses, a server refusal unchanged since - and Update All waits while any
  // edited row has one. A row's own Save waits on its own (the row's canSave).

  /** The pre-flight's verdict on each edited row, kept until the row's edit, its stored item or
   *  the lookups are other objects: the store hands back the same objects until the row
   *  changes, so Update All can ask on every change-detection pass and only the row typed in is
   *  checked again. */
  private readonly verdicts = new Map<string, { edited: ItemResponse; baseline: ItemResponse; lookups: IListingRowLookups; pricing: boolean; refused: boolean }>();

  /** The edited rows the pre-flight refuses, in page order: prepare's verdict, so Update All
   *  waits on exactly the rows it would not send. */
  private preflightRefused(): string[] {
    const ctx = this.saveContext;
    const refused: string[] = [];
    const edited = new Set<string>();
    for (const row of this.store.batch()) {
      const id = row.edited.id;
      edited.add(id);
      let verdict = this.verdicts.get(id);
      if (!verdict || verdict.edited !== row.edited || verdict.baseline !== row.baseline
        || verdict.lookups !== this.lookups || verdict.pricing !== ctx.pricing) {
        verdict = { edited: row.edited, baseline: row.baseline, lookups: this.lookups, pricing: ctx.pricing,
          refused: this.listingSaveService.refuses(row, ctx) };
        this.verdicts.set(id, verdict);
      }
      if (verdict.refused) { refused.push(id); }
    }
    for (const id of [...this.verdicts.keys()]) {
      if (!edited.has(id)) { this.verdicts.delete(id); }
    }
    return refused;
  }

  /** The edited rows with an error to fix: the pre-flight refuses them, or the server refused
   *  them and they are unchanged since (a 400). A conflicted row counts as a conflict only: it
   *  is reviewed first, and resolving it can change what is left to fix. */
  get rowsToFix(): string[] {
    const refusedByServer = this.store.editedIds.filter(id => this.isRefused(id));
    return [...new Set([...this.preflightRefused(), ...refusedByServer])].filter(id => !this.conflicts.has(id));
  }

  /** Why Update All Listings waits, a line per cause: the conflicts to review, then the rows
   *  to fix. Empty when nothing blocks it. Its count still includes those rows, and Unsaved
   *  Listings, beside it, leads to them. */
  get updateAllBlockers(): string[] {
    const review = this.conflicts.size;
    const fix = this.rowsToFix.length;
    return [
      ...(review ? [reviewOnItemsFirst(review)] : []),
      ...(fix ? [fixOnItemsFirst(fix)] : [])
    ];
  }

  /** Enter the unsaved-only view, fresh: rows saved during an earlier visit are not kept. */
  showAllUpdatedItems(): void {
    this.savedWhileFiltered.clear();
    this.showOnlyEdited = true;
  }

  /** The "Unsaved Listings" button as a toggle (HUBX-8498): legacy's only entered the
   *  unsaved-only view, so leaving it meant finishing or undoing every edit. Leaving keeps
   *  the edits. */
  toggleUnsavedListings(): void {
    if (this.showOnlyEdited) {
      this.showOnlyEdited = false;
    } else {
      this.showAllUpdatedItems();
    }
  }

  isItemsEmpty(): boolean {
    return !this.loader && !this.store.rows.length;
  }

  // Removed tab: select rows, then set each selected row's cost to its threshold

  onReactivationToggled(event: { id: string; checked: boolean }): void {
    if (event.checked) {
      this.reactivationSelected.add(event.id);
    } else {
      this.reactivationSelected.delete(event.id);
    }
    const selectable = this.store.rows.filter(r => this.isReactivationSelectable(r)).length;
    this.isAllRemovedSelected = selectable > 0 && this.reactivationSelected.size === selectable;
  }

  checkAllItemsForReactivation($event: Event): void {
    if (!this.isRemovedTab) { return; }
    this.isAllRemovedSelected = ($event.target as HTMLInputElement).checked;
    this.reactivationSelected = new Set(this.isAllRemovedSelected
      ? this.store.rows.filter(r => this.isReactivationSelectable(r)).map(r => r.item.id)
      : []);
  }

  /** The bulk cost cut: each selected row takes its own threshold as its cost - an ordinary
   *  edit in the store, saved like any other. The rows then show the reactivation notice. */
  applyCostReductionToAllSelected(): void {
    for (const id of this.reactivationSelected) {
      const threshold = this.store.row(id)?.reactivationThreshold;
      if (threshold != null) {
        this.store.edit(id, { unitPurchasePrice: threshold });
        this.bump(id);
      }
    }
    this.resetReactivationCheckboxes();
  }

  resetReactivationCheckboxes(): void {
    this.reactivationSelected = new Set();
    this.isAllRemovedSelected = false;
  }

  // ---------------------------------------------------------------------------------------
  // Save: prepare -> the offers check -> the user decides -> commit (HUBX-8477, HUBX-8511)
  // ---------------------------------------------------------------------------------------

  /** "Update All Listings". */
  checkPendingOffersAllItems(): void {
    this.startSave();
  }

  /** A row's own Save icon: that row alone. */
  checkPendingOffersSingleItem(id: string): void {
    this.startSave([id]);
  }

  private startSave(ids?: string[]): void {
    if (this.vendorService.isPortalReadOnly(true)) { return; }
    if (this.isRequestingPendingOffers || this.isUpdatingItems) { return; }
    // Nothing blocked is saved (HUBX-8466): a row's own Save waits on its conflict or its
    // server refusal - an edit the form refuses still reaches the pre-flight, which says why -
    // and Update All on anything that blocks it.
    if (ids ? ids.some(id => this.conflicts.has(id) || this.isRefused(id)) : this.updateAllBlockers.length > 0) { return; }

    const plan = this.listingSaveService.prepare(this.store, this.saveContext, ids);
    this.savePlan = plan;
    this.plannedSavedNotes = new Map();
    for (const ready of plan.ready) {
      const note = rowSavedNote(ready.request?.status, this.store.baseline(ready.id), this.role);
      if (note) { this.plannedSavedNotes.set(ready.id, note); }
    }
    this.isCheckPendingOffersSingleItem = !!ids;
    if (!plan.ready.length) {
      // Nothing may be sent; commit still reports the rows the pre-flight refused.
      this.commitSave([]);
      return;
    }

    this.isRequestingPendingOffers = true;
    this.showRefreshMsg = false;
    const localTimeInUTC = moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
    this.listingSaveService.affectedOffers(plan).subscribe({
      next: ({ plan: checked, affected }) => {
        this.isRequestingPendingOffers = false;
        // The rows whose check failed have left `ready`; commit reports them failed.
        this.savePlan = checked;
        if (!affected.length) {
          this.commitSave([]);
          return;
        }
        // What will be sent, not what was edited (HUBX-8466): a row whose check failed is not.
        this.pendingUpdatesInSave = checked.ready.length;
        this.openCancellationWarning('listing', affected.map(offer => this.decoratePendingOffer(offer)), localTimeInUTC);
      },
      // A failed check is already that row's failure (HUBX-8511); reaching here is a fault of
      // the client itself. Nothing is sent, and it is said, as a failed commit is.
      error: err => {
        this.isRequestingPendingOffers = false;
        this.sharedService.handleVendorHttpError(err, this.errorModal, this.vendorService.portal);
      }
    });
  }

  /** The one cancellation warning, for the listing's save and the Edit modal's (HUBX-8511).
   *  `from` is who gets the answer. `askedAt` is when the offers were read: Refresh asks for
   *  what changed after it. */
  private openCancellationWarning(from: 'listing' | 'modal', items: models.ItemWithPendingOffers[], askedAt: string): void {
    this.warningFrom = from;
    this.warningOverModal = from === 'modal';
    this.pendingOffers = items;
    this.calculateTotalPendigOffers();
    const partnerId = sessionStorage.getItem('partner_id');
    this.disableReviewOffersButton = this.pendingOffers.some(value => value.sellerId !== partnerId);
    sessionStorage.setItem('cancellationWarningFromDate', askedAt);
    this.showCancellationWarning = true;
  }

  /** What the cancellation warning needs per item beyond what the check returns. The seller is
   *  the row's company for an operator; a Seller's rows are its own company (`companyId` is
   *  operators only); with no row, the Edit modal's item's company (Pending PO, HUBX-8511).
   *  The logo resolves through /lookups/manufacturers (HUBX-8489), from the row on this page,
   *  else from the Edit modal's item (Pending PO has no rows, HUBX-8511). */
  private decoratePendingOffer<T extends { vendorItemId: string; offers: any[] }>(offer: T): T & { sellerId: string; manufacturerLogoUrl: string; hasPendingOffers: boolean } {
    const row = this.store.row(offer.vendorItemId);
    const item = this.store.current(offer.vendorItemId)
      ?? (this.editTarget?.id === offer.vendorItemId ? this.editTarget : undefined);
    return {
      ...offer,
      sellerId: row?.companyId
        ?? (this.editTarget?.id === offer.vendorItemId ? this.editSellerId : undefined)
        ?? sessionStorage.getItem('partner_id'),
      manufacturerLogoUrl: manufacturerLogoPath(this.lookups.manufacturers, item?.manufacturerId),
      offers: offer.offers.map(o => ({ ...o, status: enums.OfferStatusCancelationWarning.Pending })),
      hasPendingOffers: true
    };
  }

  /** The Edit modal's save would cancel offers (HUBX-8511): the page opens its own warning
   *  over the modal, so Refresh, SignalR, "Review Offers" and the confirmation are the
   *  listing's. One item, one update. */
  onModalOffersAffected(affected: models.ItemWithPendingOffers): void {
    this.showRefreshMsg = false;
    this.pendingUpdatesInSave = 1;
    this.openCancellationWarning('modal', [this.decoratePendingOffer(affected)],
      moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'));
  }

  /** The warning answered. From the listing: the rows whose offer is kept are left out and
   *  stay edited, the rest are sent. From the Edit modal: Cancel lets its PUT go, Keep leaves
   *  it open with the edit (HUBX-8511). */
  updateAfterCancelationWarning(pendingItemOffersByAction: models.PendingOfferByAction): void {
    const kept = pendingItemOffersByAction.pendingOffersToKeep.map(i => i.vendorItemId);
    if (this.warningFrom === 'modal') {
      // Answered: the close that follows must not answer again.
      this.warningFrom = 'listing';
      if (kept.length) {
        this.writeModal?.keepEdit();
      } else {
        this.writeModal?.continueSave();
      }
      return;
    }
    this.commitSave(kept);
  }

  private commitSave(keptIds: string[]): void {
    if (!this.savePlan) { return; }
    this.isUpdatingItems = true;
    this.saveSubscription.unsubscribe();
    this.saveSubscription = this.listingSaveService.commit(this.store, this.savePlan, keptIds).subscribe({
      next: event => event.kind === 'row' ? this.applyOutcome(event.outcome) : this.applySaveSummary(event.summary),
      error: err => {
        this.isUpdatingItems = false;
        this.sharedService.handleVendorHttpError(err, this.errorModal, this.vendorService.portal);
      }
    });
  }

  /** One row settled (already folded into the store). The minimum of HUBX-8478: every row
   *  stays on the page; a failed one shows its reason from the shared catalogue, keyed by the
   *  ProblemDetails code. The success mark and its fade are HUBX-8478. */
  private applyOutcome(outcome: RowSaveOutcome): void {
    this.bump(outcome.id);
    switch (outcome.status) {
      case 'saved':
        this.saveErrors.delete(outcome.id);
        this.conflicts.delete(outcome.id);
        this.markSaved(outcome.id);
        if (this.showOnlyEdited) {
          this.savedWhileFiltered.add(outcome.id);
        }
        break;
      case 'failed': {
        this.clearSaved(outcome.id);
        // The 412 is intercepted before the catalogue, as in the modal: it owns the amber
        // notice and Review changes, never the red line (item-write-messages, ERROR_INFO).
        if (outcome.httpStatus === 412 || outcome.problem?.code === EDIT_ERROR_CODES.concurrencyConflict) {
          this.applyConflict(outcome.id, outcome.problem?.currentState);
          break;
        }
        const info = errorFor(outcome.problem?.code ?? undefined, outcome.problem?.data);
        const message = info?.message ?? genericWriteError(true);
        this.saveErrors.set(outcome.id, message);
        // A 400 is the server refusing the data: sent again unchanged it is refused again, so
        // the row waits for an edit (HUBX-8466). Any other failure is the retry's to clear.
        if (outcome.httpStatus === 400) {
          this.refusals.set(outcome.id, { message, problem: outcome.problem });
        } else {
          this.refusals.delete(outcome.id);
        }
        if (info?.dqFromQty !== undefined) {
          this.saveErrorTiers.set(outcome.id, { message, fromQty: info.dqFromQty });
        } else {
          this.saveErrorTiers.delete(outcome.id);
        }
        break;
      }
      case 'invalid':
        this.clearSaved(outcome.id);
        this.refusals.delete(outcome.id);
        this.saveErrors.set(outcome.id, listingInvalidMessage(outcome.errors));
        break;
    }
  }

  /** Marked now; the fade waits for the popup (startSavedFade). */
  private markSaved(id: string): void {
    this.clearSaved(id);
    this.justSaved.add(id);
    const note = this.plannedSavedNotes.get(id);
    if (note) { this.savedNotes.set(id, note); }
  }

  /** The popup closed, or none opened (a row's own Save): every mark not yet fading starts its
   *  countdown. A mark already fading from an earlier save keeps its own. */
  private startSavedFade(): void {
    this.justSaved.forEach(id => {
      if (this.savedTimers.has(id)) { return; }
      this.savedTimers.set(id, setTimeout(() => {
        this.justSaved.delete(id);
        this.savedNotes.delete(id);
        this.savedTimers.delete(id);
      }, ItemsComponent.SAVED_MARK_MS));
    });
  }

  private clearSaved(id: string): void {
    const timer = this.savedTimers.get(id);
    if (timer !== undefined) { clearTimeout(timer); }
    this.savedTimers.delete(id);
    this.justSaved.delete(id);
    this.savedNotes.delete(id);
  }

  private clearAllSaved(): void {
    this.savedTimers.forEach(timer => clearTimeout(timer));
    this.savedTimers.clear();
    this.justSaved.clear();
    this.savedNotes.clear();
  }

  /** A 412 on one row (HUBX-8478, design block B): marked in that row alone. Not rebased
   *  (HUBX-8466): the row keeps its baseline, its tokens and its edit until it is resolved in
   *  the resolve popup, and nothing saves it before then. */
  private applyConflict(id: string, currentState?: ItemResponse): void {
    const baseline = this.store.baseline(id);
    const edited = this.store.current(id);
    if (!baseline || !edited) { return; }
    this.conflicts.set(id, rowConflictMarks(baseline, edited, currentState, this.lookups));
    this.saveErrors.delete(id);
  }

  /** Discard my changes without the popup - a conflicted row's Undo, or Undo on the whole page: the
   *  rows are re-read (GET /items?ids=) and take the version the server holds now. A real
   *  re-read rather than the 412's payload, as the modal's: the payload may be absent, and the
   *  item may have moved again since. A row the re-read does not return keeps its conflict and
   *  says the re-read failed, so it can be tried again. */
  private discardConflicts(ids: string[]): void {
    this.itemListingService.getByIds(ids).subscribe({
      next: rows => {
        this.store.refill(rows);
        const returned = new Set(rows.map(r => r.item.id));
        for (const id of ids) {
          if (!returned.has(id)) {
            this.saveErrors.set(id, RELOAD_FAILED);
            continue;
          }
          this.store.undo(id);
          this.conflicts.delete(id);
          this.saveErrors.delete(id);
          this.bump(id);
        }
      },
      error: () => ids.forEach(id => this.saveErrors.set(id, RELOAD_FAILED))
    });
  }

  /** Review changes on a conflicted row (HUBX-8466): the resolve popup opens and the row is
   *  re-read for it. */
  reviewConflict(id: string): void {
    if (!this.conflicts.has(id)) { return; }
    this.resolveId = id;
    this.readResolve();
  }

  /** The re-read behind the popup: what the server holds now, compared with what the row
   *  shows and with what it was read as. Also the popup's Try again. */
  readResolve(): void {
    const id = this.resolveId;
    if (!id) { return; }
    this.resolveRows = null;
    this.resolveError = null;
    this.resolveFresh = null;
    this.itemListingService.getByIds([id]).subscribe({
      next: rows => {
        if (this.resolveId !== id) { return; }
        const fresh = rows.find(r => r.item.id === id);
        const baseline = this.store.baseline(id);
        const mine = this.store.current(id);
        if (!fresh || !baseline || !mine) {
          this.resolveError = RELOAD_FAILED;
          return;
        }
        this.resolveFresh = fresh;
        this.resolveRows = resolveRows(itemSide(baseline), itemSide(fresh.item), itemSide(mine),
          fresh.item.writableFields ?? [], this.lookups);
      },
      error: () => {
        if (this.resolveId === id) { this.resolveError = RELOAD_FAILED; }
      }
    });
  }

  /** The popup answered: the re-read row becomes the baseline - its tokens and writableFields
   *  with it - and the edit becomes that row plus the members kept as Yours. Nothing is saved:
   *  the row is saved as any edited row is, through its Save icon or Update All. */
  onResolved(choices: Map<string, ResolveChoice>): void {
    const id = this.resolveId;
    const fresh = this.resolveFresh;
    const edited = id ? this.store.current(id) : undefined;
    if (!id || !fresh || !edited || !this.resolveRows) { return; }
    const next = resolvedEdit(fresh.item, edited, this.resolveRows, choices, this.lookups);
    this.store.refill([fresh]);
    this.store.set(id, next);
    this.conflicts.delete(id);
    this.saveErrors.delete(id);
    this.clearSaved(id);
    this.bump(id);
    this.closeResolve();
  }

  /** Cancel or the X: the conflict stays open. */
  closeResolve(): void {
    this.resolveId = null;
    this.resolveRows = null;
    this.resolveError = null;
    this.resolveFresh = null;
  }

  get resolvePartNumber(): string {
    return (this.resolveId && this.store.row(this.resolveId)?.item.vendorItemCode) || '';
  }

  private applySaveSummary(summary: IListingSaveSummary): void {
    this.isUpdatingItems = false;
    // Kept rows stay edited (HUBX-8511); saved rows took the refill as their new baseline.
    [...summary.kept, ...summary.saved].forEach(id => this.bump(id));
    this.savePlan = undefined;
    this.totalUpdatedItemsCount = summary.saved.length;
    this.totalFailedItemsCount = summary.failed.length + summary.invalid.length;
    this.totalKeptItemsCount = summary.kept.length;
    // Kept rows alone do not open it: the user chose Keep in the warning just closed. A row's
    // own Save never opens it (HUBX-8466): that row already says how it went - "Saved.", its
    // error line or the conflict notice - so its mark starts fading now.
    this.isModalShown = !this.isCheckPendingOffersSingleItem
      && this.totalUpdatedItemsCount + this.totalFailedItemsCount > 0;
    if (!this.isModalShown) {
      this.startSavedFade();
    }
    // Never GET /items after a save: the counters and the filter options only.
    if (summary.saved.length) {
      this.load('save');
    }
  }

  calculateTotalPendigOffers(): void {
    this.totalPendingOffers = 0;
    this.pendingOffers.forEach(po => {
      po.offers.forEach(offer => {
        if (offer.status === enums.OfferStatusCancelationWarning.Pending) {
          this.totalPendingOffers++;
        }
      });
    });
  }

  handleNewOfferEventReceived(offerEvent: models.IOfferEventMessage): void {
    const offerIdToCheck = offerEvent.offerId;

    if (offerEvent.eventType === enums.OfferEventTypes.OfferMade) { // an offer made on an item that is about to be saved
      const existsInPendings = this.pendingOffers.some(pendingOffer => pendingOffer.offers.some(o => o.id === offerEvent.offerId));
      if (existsInPendings) {
        return;
      }

      this.offersSubscriptions.push(this.offerService.getOfferById(offerEvent.offerId)
        .subscribe(
          (offer: models.Offer) => {
            // An edited row, or the item the Edit modal is saving (HUBX-8511).
            if (this.store.isEdited(offer.vendorItemId)
              || (this.showWriteModal && offer.vendorItemId === this.editTarget?.id)) {
              this.offerService.offersCancellationPopupSettings.show = false;
              this.showRefreshMsg = true;
            }
          },
          (err) => { console.log('Error trying to get offer by id ', err); }
        ));
    }

    if (offerEvent.eventType !== enums.OfferEventTypes.OfferMade) {
      const exists = this.pendingOffers.some(pendingOffer =>
        pendingOffer.offers.some(offer => offer.id === offerIdToCheck)
      );
      if (exists) {
        this.offerService.offersCancellationPopupSettings.show = false;
        this.showRefreshMsg = true;
      }
    }
  }

  closeCancellationWarningModal(): void {
    this.showCancellationWarning = false;
    this.pendingOffers = [];
    // Closed without Update (its X or Escape) over the Edit modal: nothing is saved, and the
    // modal stays open with the edit (HUBX-8511).
    if (this.warningFrom === 'modal') {
      this.warningFrom = 'listing';
      this.writeModal?.keepEdit();
    }
  }

  refreshCancellationWarningModal(): void {
    this.showRefreshMsg = false;
    const localTimeInUTC = moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');

    // The items being saved: the listing's ready rows, or the Edit modal's item (HUBX-8511).
    const itemIds = this.warningFrom === 'modal' && this.editTarget
      ? [this.editTarget.id]
      : (this.savePlan?.ready ?? []).map(r => r.id);
    const payload = { itemIds } as models.PendingOfferRequest;

    this.offerService.loadingOfferCancelationData = true;
    this.offersSubscriptions.push(
      this.offerService.getPendingOffersFromDate(payload).subscribe(
        (response: models.ItemWithPendingOffers[]) => {
          sessionStorage.setItem('cancellationWarningFromDate', localTimeInUTC);

          response.forEach(updatedItem => {
            const itemInPendingOffers = this.pendingOffers.find(item =>
              item.vendorItemId === updatedItem.vendorItemId
            );

            if (itemInPendingOffers) {
              updatedItem.offers.forEach(newOrUpdatedOffer => {
                const offerInPendingOffers = itemInPendingOffers.offers.find(offer => offer.id === newOrUpdatedOffer.id);

                if (offerInPendingOffers) {
                  offerInPendingOffers.itemPrice = newOrUpdatedOffer.itemPrice;
                  offerInPendingOffers.offerPrice = newOrUpdatedOffer.offerPrice;
                  offerInPendingOffers.units = newOrUpdatedOffer.units;
                  offerInPendingOffers.total = newOrUpdatedOffer.total;
                  offerInPendingOffers.status = newOrUpdatedOffer.status;
                } else { // an offer made meanwhile: add it
                  itemInPendingOffers.offers.push(newOrUpdatedOffer);
                }
              });
              this.verifyItemHasPendingOffers(itemInPendingOffers.vendorItemId);
            } else {
              const decorated = this.decoratePendingOffer(updatedItem);
              this.pendingOffers.push(decorated);
              this.offerCancelationWarningComponent.addItemOffersToFormArray(decorated);
              this.offerCancelationWarningComponent.checkForOffersUpdates();
            }
          });

          const partnerId = sessionStorage.getItem('partner_id');
          this.disableReviewOffersButton = this.pendingOffers.some(value => value.sellerId !== partnerId);
          this.calculateTotalPendigOffers();
          this.offerService.loadingOfferCancelationData = false;
        },
        (error) => {
          this.showRefreshMsg = true;
          this.offerService.loadingOfferCancelationData = false;
          console.log(error, ' Error getting cancellation warning data');
        })
    );
  }

  verifyItemHasPendingOffers(itemId: string): void {
    const index = this.pendingOffers.findIndex(po => po.vendorItemId === itemId);
    const pendingItemOffers = this.pendingOffers[index];
    let counterOfNoPendingOffers = 0;
    pendingItemOffers.offers.forEach(offer => {
      if (offer.status !== enums.OfferStatusCancelationWarning.Pending) {
        counterOfNoPendingOffers++;
      }
    });
    if (counterOfNoPendingOffers === pendingItemOffers.offers.length) {
      pendingItemOffers.hasPendingOffers = false;
    }
  }

  // ---------------------------------------------------------------------------------------
  // Success / error chrome
  // ---------------------------------------------------------------------------------------

  showSuccessAlert(): void {
    this.isModalShown = true;
  }

  onHidden(): void {
    this.isModalShown = false;
  }

  hideModal(): void {
    this.isModalShown = false;
  }

  get saveResultTitle(): string {
    if (!this.totalFailedItemsCount) { return SAVE_RESULT_TITLE.saved; }
    return this.totalUpdatedItemsCount ? SAVE_RESULT_TITLE.partial : SAVE_RESULT_TITLE.failed;
  }

  getItemsText(): string {
    return itemsSavedText(this.totalUpdatedItemsCount);
  }

  getFailedItemsText(): string {
    return itemsNotSavedText(this.totalFailedItemsCount);
  }

  /** The popup's `note` line (HUBX-8511): the rows the user kept back in the offers warning. */
  getKeptItemsText(): string {
    return itemsKeptText(this.totalKeptItemsCount);
  }

  hideSuccessAlert(): void {
    this.isModalShown = false;
    this.startSavedFade();
  }

  /** The popup's second button, only when a row did not save (HUBX-8498): on a page of 25
   *  the rows that failed can be off screen, so it closes the popup, applies the unsaved-only
   *  view - after a save those are the rows that failed and the rows kept back in the offers
   *  warning (HUBX-8511) - and brings the list's top into view. */
  get saveResultAction(): string {
    return this.totalFailedItemsCount || this.totalKeptItemsCount ? SHOW_UNSAVED_ACTION : '';
  }

  showUnsavedFromResult(): void {
    this.hideSuccessAlert();
    this.showAllUpdatedItems();
    // After the filtered list renders. Optional calls: the element may be gone (or stubbed).
    setTimeout(() => this.elRef.nativeElement.querySelector?.('.items-list')?.scrollIntoView?.({ block: 'start' }));
  }

  hideCreateSuccess(): void {
    this.showCreateSuccessModal = false;
  }

  hideErrorAlert(): void {
    this.errorModal = { isError400: false, errorMessage400: '' };
  }

  // ---------------------------------------------------------------------------------------
  // The write modal
  // ---------------------------------------------------------------------------------------

  /**
   * Edit from a listing row (HUBX-8388, HUBX-8480). No GET: the row already holds the item as
   * stored - `row.item` IS what GET /items/{id} returns - and it is the baseline the row's own
   * edit was made against. That edit, when there is one, opens with it (`editPending`), so the
   * popup shows what the row shows. A stale row answers the PUT with a 412, which the modal
   * resolves exactly as for an item it fetched. A row refused with a 400 hands the popup that
   * 400 (`editRefusal`), so it opens ringed and its Save waits, as the row's does (HUBX-8466).
   */
  openEditFromRow(row: IListingRow): void {
    // SellerAutomation vendors are read-only in the portal for their own users (2026-09-11).
    if (this.vendorService.isPortalReadOnly(true)) {
      return;
    }
    const id = row.item.id;
    this.cloneSeed = undefined;
    this.cloneSource = undefined;
    this.editTarget = this.store.baseline(id) ?? row.item;
    this.editPending = this.store.isEdited(id) ? this.store.current(id) : undefined;
    this.editRefusal = this.editPending ? this.refusalOf(id) : undefined;
    this.editHeader = {
      priceDrop: row.priceDrop,
      justLaunched: row.justLaunched,
      launchedOn: row.lastActivatedOn,
      updatedOn: row.lastUpdatedOn
    };
    this.editReactivationThreshold = row.reactivationThreshold;
    this.editRowId = id;
    this.editSellerId = undefined;
    this.showWriteModal = true;
  }

  /**
   * Edit by fetching the item (GET /items/{id}) - what pending-sold uses: its lines are SAP
   * purchase-order lines, not listing rows, so there is no stored row or edit to open with.
   */
  openEditVendorItemInDetailedMode(item: IVendorItemInfo, index?: number): void {
    if (this.vendorService.isPortalReadOnly(true)) {
      return;
    }
    this.loader = true;
    this.editSubscription?.unsubscribe();
    this.editSubscription = this.itemCreateService.getItem(item.id).subscribe({
      next: target => {
        this.loader = false;
        this.cloneSeed = undefined;
        this.cloneSource = undefined;
        this.editTarget = target;
        this.editPending = undefined;
        this.editRefusal = undefined;
        this.editHeader = ItemsComponent.buildEditHeader(item);
        this.editReactivationThreshold = undefined;
        this.editRowId = undefined;
        this.editSellerId = item.seller?.id;
        this.showWriteModal = true;
      },
      error: err => {
        this.loader = false;
        this.sharedService.handleVendorHttpError(err, this.errorModal, this.vendorService.portal);
      }
    });
  }

  /** The Edit header from a LEGACY row (pending-sold). The badge predicate matches the old
   *  expanded view: the row carries an attribute whose LABEL is the promo name. */
  private static buildEditHeader(item: IVendorItemInfo): IEditHeader {
    const carries = (label: string) => !!item.attributes?.some(a => a.label === label);
    return {
      priceDrop: carries('Price Drop'),
      justLaunched: carries('Just Launched'),
      launchedOn: item.lastActivatedOn,
      updatedOn: item.lastUpdatedOn
    };
  }

  openCreateItemModal(): void {
    if (this.vendorService.isPortalReadOnly(true)) {
      return;
    }
    // Plain "Add Item": a blank Create, never seeded and with no source header.
    this.cloneSeed = undefined;
    this.cloneSource = undefined;
    this.editTarget = undefined;
    this.editPending = undefined;
    this.editRefusal = undefined;
    this.editSellerId = undefined;
    this.showWriteModal = true;
  }

  /** Clone (HUBX-8368): fetch the row's canonical item (GET /items/{id}) and open the Create
   *  modal seeded from it. The source header is only committed once the fetch succeeds. */
  onClone(source: ICloneSource): void {
    if (this.vendorService.isPortalReadOnly(true)) {
      return;
    }
    this.loader = true;
    this.cloneSubscription?.unsubscribe();
    this.cloneSubscription = this.itemCreateService.getItem(source.id).subscribe({
      next: seed => {
        this.loader = false;
        this.editTarget = undefined;
        this.editPending = undefined;
        this.editRefusal = undefined;
        this.editSellerId = undefined;
        this.cloneSeed = seed;
        this.cloneSource = source;
        this.showWriteModal = true;
      },
      error: err => {
        this.loader = false;
        this.sharedService.handleVendorHttpError(err, this.errorModal, this.vendorService.portal);
      }
    });
  }

  closeWriteModal(): void {
    this.showWriteModal = false;
    this.cloneSeed = undefined;
    this.cloneSource = undefined;
    this.editTarget = undefined;
    this.editPending = undefined;
    this.editRefusal = undefined;
    this.editHeader = undefined;
    this.editReactivationThreshold = undefined;
    this.editRowId = undefined;
    this.editSellerId = undefined;
  }

  /** A new item was created (Create or Clone). It belongs to the result set, so the page is
   *  fetched again with both aggregates - it can bring a new manufacturer, category... into
   *  the filter options - unless the page holds unsaved edits, which a fetch would discard
   *  without asking: then only the counters and the filter options move, and the new item
   *  appears on the next page load. */
  onItemCreated(created: { id: string; vendorItemCode: string; categoryNotice?: string }): void {
    this.closeWriteModal();
    this.createSuccessMsg = `'${created.vendorItemCode}' was created.`;
    this.createCategoryNotice = created.categoryNotice ?? '';
    this.showCreateSuccessModal = true;
    this.load(this.store.needsDiscardConfirmation ? 'save' : 'create');
  }

  /** An item was saved from the popup (HUBX-8388). As after a row save: its row is refilled by
   *  id (HUBX-8488) and the aggregates refetched - never the page. The popup sent the row's
   *  pending edit too, so that edit is done with. The aggregates move even when the item is
   *  not on this page: the save changed the vendor's catalogue either way (HUBX-8487). */
  onItemSaved(saved: { id: string; vendorItemCode: string; categoryNotice?: string; statusNotice?: string }): void {
    this.closeWriteModal();
    this.editSuccessMsg = `'${saved.vendorItemCode}' was saved.`;
    this.editCategoryNotice = editSuccessNote(saved.statusNotice, saved.categoryNotice);
    this.showEditSuccessModal = true;
    this.load('save');
    if (!this.store.row(saved.id)) { return; }

    // Marked as a row's own Save or Update All mark it (HUBX-8466): "Saved.", or the note the
    // popup confirmed, fading once its confirmation is closed (hideEditSuccess); and under
    // "Unsaved Listings" the row stays in the view until it is left (HUBX-8498). Before the
    // undo, which may take the last edit and close the view.
    if (this.showOnlyEdited) {
      this.savedWhileFiltered.add(saved.id);
    }
    this.clearSaved(saved.id);
    this.justSaved.add(saved.id);
    if (saved.statusNotice) {
      this.savedNotes.set(saved.id, saved.statusNotice);
    }
    this.store.undo(saved.id);
    this.saveErrors.delete(saved.id);
    // A conflict the popup ran into and resolved is the row's too (onModalConflicted).
    this.conflicts.delete(saved.id);
    this.bump(saved.id);
    this.refillSubscription.unsubscribe();
    this.refillSubscription = this.itemListingService.getByIds([saved.id]).subscribe({
      next: rows => {
        this.store.refill(rows);
        this.bump(saved.id);
      },
      error: err => console.log('Error refilling the saved row', err)
    });
  }

  /** Undo in the popup (HUBX-8480) takes back the whole pending edit of its item, the row's
   *  included: the row goes back to the stored item exactly as with its own Undo, and the
   *  counters with it. The other rows' edits stay. Nothing to do when the row held no edit. */
  onModalUndone(id: string): void {
    this.editPending = undefined;
    this.editRefusal = undefined;
    if (!this.store.undo(id)) { return; }
    this.bump(id);
    this.onRowEdited(id);
  }

  /** A Save from the popup was answered with a 412 (HUBX-8466). The row of that item was read
   *  as long ago as the popup's target, so it is stale too:
   *
   *  - with no edit, it is re-read (GET /items?ids=), as after a save - nothing of the user's
   *    is at stake;
   *  - with an edit - the one the popup opened with - it is conflicted exactly as on its own
   *    412: the notice with Review changes, its Save and Update All blocked. Re-reading the
   *    baseline under that edit would be the silent rebase the 412 no longer does: the next
   *    Save would carry the edit's stale members with fresh tokens.
   *
   *  The popup's own outcome then settles the row: saved (onItemSaved), Undo or Discard my changes
   *  (onModalUndone, which re-reads a conflicted row). An item not on this page (pending-sold)
   *  has no row to settle. */
  onModalConflicted(event: { id: string; currentState?: ItemResponse }): void {
    const id = event.id;
    if (!this.store.row(id)) { return; }
    if (this.store.isEdited(id)) {
      this.applyConflict(id, event.currentState);
      this.clearSaved(id);
      this.bump(id);
      return;
    }
    this.itemListingService.getByIds([id]).subscribe({
      next: rows => {
        this.store.refill(rows);
        if (rows.some(r => r.item.id === id)) {
          this.conflicts.delete(id);
          this.saveErrors.delete(id);
        }
        this.bump(id);
      },
      error: err => console.log('Error re-reading the row after a conflict', err)
    });
  }

  hideEditSuccess(): void {
    this.showEditSuccessModal = false;
    // The saved row's mark starts fading now that the confirmation is out of the way.
    this.startSavedFade();
  }

  // ---------------------------------------------------------------------------------------
  // Export (legacy ExportListing, unchanged: it takes the legacy SkuStatus ordinals)
  // ---------------------------------------------------------------------------------------

  triggerExportTooltip(exportReq: NgForm): void {
    exportReq.resetForm();
    this.isAllExport = false;
    this.isShowExportTooltip = !this.isShowExportTooltip;
  }

  triggerExportAll(): void {
    this.isAllExport = !this.isAllExport;
  }

  hideExportTooltip($event): void {
    this.isShowExportTooltip = false;
  }

  getFilteredOptions(exportReq: NgForm): void {
    const checkedOptions = Object.keys(exportReq.value).map((x) => Number(x));
    this.exportReqOptions = checkedOptions.filter(key => exportReq.value[key]);
  }

  isOptionNotSelected(exportReq: NgForm): boolean {
    this.getFilteredOptions(exportReq);
    return !(this.exportReqOptions && this.exportReqOptions.length > 0);
  }

  export(exportReq: NgForm): void {
    this.isExporting = true;
    this.getFilteredOptions(exportReq);
    this.exportReq = {
      OptionELId: this.exportReqOptions,
    };

    this.vendorService.exportItemList(this.exportReq).subscribe(data => {
      const fileName = data.headers.get('content-disposition').split(';')[1].split('"')[1];
      importedSaveAs(data.body, fileName);
      this.isShowExportTooltip = false;
      this.isAllExport = false;
      exportReq.resetForm();
      this.isExporting = false;
    },
      (err) => {
        this.isExporting = false;
        this.sharedService.handleVendorHttpError(err, this.errorModal, this.vendorService.portal);
      });
  }
}
